import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

/**
 * Route guard HOC.
 * - If no JWT cookie is present → redirect to /login.
 * - If requiredRole is provided and the user's role doesn't match → redirect to /.
 * - Otherwise, render the protected element.
 *
 * Usage:
 *   <Route path="/writerdash" element={<ProtectedRoute element={<WriterDashboard />} requiredRole="ROLE_WRITER" />} />
 */
const ProtectedRoute = ({ element, requiredRole }) => {
  const token = Cookies.get('jwtToken');
  const role = Cookies.get('userRole');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    const allowed = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!allowed.includes(role)) {
      return <Navigate to="/" replace />;
    }
  }

  return element;
};

export default ProtectedRoute;
